import MemberBenefits from 'assets/svgs/onboarding/member-benefits.svg';
import { ButtonOutlined } from 'platfi-ui-components';
import { IntercomAPI } from 'react-intercom';

export default ({ completeOnboarding }) => {
  const bookConsultation = () => {
    IntercomAPI('trackEvent', 'enquiry-about-plan');
    IntercomAPI('show');
    completeOnboarding();
  };

  return [
    {
      icon: 'logo',
      label: 'Welcome',
      lead: 'You’ve gained access to the Capitalise member benefit programme. Let’s see what you’ll have access to...',
      title: 'A few steps to get started!',
    },
    {
      content: () => <MemberBenefits />,
      icon: 'rocket',
      label: 'Learn',
      lead: 'Capitalise Learn breaks down the funding process into bite-sized lessons. Complete every lesson to unlock your CPD certificate.',
      title: 'Bite sized lessons',
    },
    {
      content: () => (
        <ButtonOutlined onClick={bookConsultation} primary>
          Book Consultation
        </ButtonOutlined>
      ),
      icon: 'demo',
      lead: "<strong>50% of SME's</strong> will have a funding need in the next 12 months. If you or a client has a funding need our  team is here to help.",
      nextButtonLabel: 'Let me in',
      label: 'Funding',
      title: 'Our team are experts in funding advisory',
    },
  ];
};
